/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */

import { deleteUserUrl } from '@modules/cloud-api/v1/urls'
import type { User } from '@modules/cloud-api/v1/types'
import type { RegionId } from '@modules/ui-types'

import asyncRequest from '../asyncRequests'
import { DELETE_USER } from '../../constants/actions'

import type { ThunkAction } from '@/types/redux'

export function deleteNativeUser(regionId: RegionId, payload: User): ThunkAction {
  return (dispatch) => {
    const { user_name } = payload
    const url = deleteUserUrl({ userName: user_name })

    return dispatch(
      asyncRequest({
        type: DELETE_USER,
        url,
        method: `delete`,
        meta: { user_name },
        payload,
        crumbs: [regionId],
      }),
    )
  }
}
